import {
  deleteArticle as deleteArticleIndicator, deletePublication as removePublication,
  validateArticle as validateArticleIndicator,
  validateArticleByResearchCommittee as validateArticleIndicatorByResearchCommittee,
} from './api'

const validateArticle = async({ commit }, payload) => {
  try {
    const response = await validateArticleIndicator(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const validateArticleByResearchCommittee = async({ commit }, payload) => {
  try {
    const response = await validateArticleIndicatorByResearchCommittee(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const deleteArticle = async({ commit }, payload) => {
  try {
    const response = await deleteArticleIndicator(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

const deletePublication = async({ commit }, payload) => {
  try {
    const response = await removePublication(payload)
    
    return response.data.data
  } catch (e) {
    console.error(e)
  }
}

export default {
  validateArticle,
  validateArticleByResearchCommittee,
  deleteArticle,
  deletePublication,
}
